import React from "react";
import { useTranslation } from "react-i18next";
import NewsletterStatusPage from "./NewsletterStatusPage";

const NewsletterConfirmedPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <NewsletterStatusPage
      path="/newsletter/confirmed"
      pageTitle={t("newsletter.confirmedTitle")}
      seoTitle={t("newsletter.confirmedTitle")}
      seoDescription={t("newsletter.confirmedMessage")}
      icon="✅"
      heading={t("newsletter.confirmedHeading")}
      message={t("newsletter.confirmedMessage")}
    />
  );
};

export default NewsletterConfirmedPage;
